import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  isDirectSearch: false,
  directSearchValue: '',
  userInput: [],
  allData: '',
  isLoading: false,
  isEmpty: true,
  error: '',
  isError: false,
  getResponse: false,
  functionName: '',
  showingValue: null
}

export const fetchData = createAsyncThunk('Users/fetchUsers', async (inputvalue) => {
  let key = 'AIzaSyBsIeJpcvLfHxM-d1CcTmgl_iEzW0Ci2EU'
const {
    GoogleGenerativeAI,
  } = require("@google/generative-ai");
  const genAI = new GoogleGenerativeAI(key);
  const model = genAI.getGenerativeModel({
    model: "gemini-2.5-flash",
  });
  const generationConfig = {
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
  };

    const chatSession = model.startChat({
      generationConfig,
      history: [
      ],
    });
    const result = await chatSession.sendMessage(inputvalue);
    return result.response.text()
}
)


export const userData = createSlice({
  name: 'Users',
  initialState,
  reducers: {
    fetchInput: (state, action) => {
      const allreadyInputs = state.userInput.find((item) => item === action.payload)
       if(!allreadyInputs) {
        state.userInput.splice(0,0,action.payload)
        state.isEmpty = false
        state.showingValue = action.payload
      }

      },
      fetchSearch: ( state ,action) => {
      let index = action.payload
       state.directSearchValue = state.userInput[index] 
       state.showingValue = state.userInput[index]
      },
      directSerachTrue: (state) => {
      state.isDirectSearch = true
      },
      directSerachFalse: (state) => {
        state.isDirectSearch = false
      },
      fetchFunction: (state, action) => {
        state.functionName = action.payload.name
      },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchData.pending, (state) => {
      state.allData = ''
     state.isLoading = true
     state.getResponse = false
    }).addCase(fetchData.fulfilled, (state, action) => {
    state.isLoading = false
    state.isError = false
    state.getResponse = true
    state.allData = action.payload
    }).addCase(fetchData.rejected, (state, action) => {
      console.log(action)
       state.isLoading = false
       state.isError = true
       state.getResponse = true
       state.error = action.error.message || "something went wrong"
    })
  }
})
export const {fetchInput, fetchSearch, directSerachFalse, directSerachTrue, fetchFunction} = userData.actions

export default userData.reducer